import React from "react";
import PopUp from '../../GeneralComponents/PopUp';

const DeleteComponentPopUpWindow = (props) => {

    const { 
        handleClose,
        confirmDeleteComponent,
        component,
        open,
        setOpen
    } = props;


    return(
        
        <PopUp
            openAlert={open}
            setOpenAlert={setOpen}
            handleCancel={handleClose}
            handleConfirm={confirmDeleteComponent}    
            title={`Delete ${component}`}
            insideDescription ={`Are you sure you want to delete this ${component}  ?`}
            cause={`delete${component}`}
            confirmText='Delete'
            cancelText='Cancel'
        />
    )
}

export default DeleteComponentPopUpWindow